import { useEffect, useLayoutEffect } from 'react'

const useIsomorphicLayoutEffect = IS_SSR ? useEffect : useLayoutEffect

export default useIsomorphicLayoutEffect
